import type { Agent } from "@/react/types/CommunityBot/ChatSort";
import { Icon } from "@circle-react-shared/Icon";
import { Dropdown } from "@circle-react-shared/uikit/Dropdown";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface AgentDropdownProps {
  activeItem: Agent;
  className?: string;
  dataTestId?: string;
  items: Agent[];
  onItemClick: (item: Agent) => void;
}

export const AgentDropdown = ({
  className,
  activeItem,
  onItemClick,
  items,
  dataTestId,
}: AgentDropdownProps) => (
  <Dropdown
    direction="bottom-start"
    className={className}
    buttonClassName="w-32"
    menuItemsClassName="!w-40"
    buttonDataTestId={dataTestId}
    button={
      <Dropdown.MenuButton className="hover:bg-secondary-dark border-primary flex h-[34px] !w-fit justify-between !gap-1 rounded-md border bg-transparent !py-1.5 pl-3 pr-2 transition-colors">
        <div className="max-w-18 gap-x-2 truncate text-left">
          <Typography.LabelSm weight="medium">
            {activeItem.name}
          </Typography.LabelSm>
        </div>
        <div className="shrink-0">
          <Icon
            size={16}
            type="16-chevron-triangle-down-small"
            className="text-dark"
          />
        </div>
      </Dropdown.MenuButton>
    }
  >
    {items.map((item: Agent) => {
      const { name, id } = item;
      return (
        <Dropdown.Item key={id} onClick={() => onItemClick(item)}>
          <Dropdown.ItemLink
            type="button"
            active={activeItem.id === id}
            aria-label={name}
          >
            <div className="flex items-center gap-x-2">
              <span className="block w-full truncate">{name}</span>
            </div>
          </Dropdown.ItemLink>
        </Dropdown.Item>
      );
    })}
  </Dropdown>
);
